import { CurrentUser } from "protogen/auth_pb";
import parsePhoneNumberFromString from "libphonenumber-js";

export const ROLE_ADVISOR = "advisor";

export const ROLE_ADMIN = "admin";
export const ROLE_SUPERADMIN = "superadmin";

const cleanPhone = (phone: string) => {
  if (phone === "+" || phone === "+1") {
    return "";
  }
  return phone;
};

const checkPhone = (phone: string) => /^\+1\d{10}$/i.test(phone);

const checkInternationalPhone = (phoneNumber: string) => {
  if (!phoneNumber) {
    return false;
  }

  try {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    return phoneNumberObj?.isValid() ?? false;
  } catch (error) {
    return false;
  }
};

const hasOneOfRoles = (user: CurrentUser, roles: string[]) =>
  user.roles.filter((r) => roles.includes(r)).length > 0;

const hasRole = (user: CurrentUser, role: string) => user.roles.includes(role);

const isUserAdmin = (user: CurrentUser) => hasRole(user, ROLE_ADMIN);
const isUserAdvisor = (user: CurrentUser) => hasRole(user, ROLE_ADVISOR);
const isUserSuperadmin = (user: CurrentUser) => hasRole(user, ROLE_SUPERADMIN);

const isValidEmail = (email: string) => {
  // HTML5 spec for valid email.  It catches ***@foo.com@bar.com - which others
  // on SO don't.
  // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  // Updating to require top level domain (.com, .net, etc)
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/i.test(
    email,
  );
};

export {
  isValidEmail,
  cleanPhone,
  checkPhone,
  checkInternationalPhone,
  isUserAdmin,
  isUserSuperadmin,
  isUserAdvisor,
  hasRole,
  hasOneOfRoles,
};
